import React, { useState, useEffect, useRef } from "react";
import ReactSVG from "react-svg";
import { Form, Field, FieldArray, submit, getFormValues, getFormSyncErrors } from "redux-form";
import { reduxFormWrapper } from "helpers";
import { debounce, isEmpty } from "lodash";
import moment from "moment";
// import { Input, ComboBox, CheckBox, CheckBoxToggle } from "ui-core-dashboard";
import { CheckBoxToggle } from "ui-core-dashboard";
import ComboBox from "../ComboBox";
import Input from "../Input";
import cx from "classnames";
import { connect } from "react-redux";
import Loader from "../Loader";
import baseService from "services/BaseService";
import { showNotification } from "actions/ui";
import CalendarContainer from "../CustomDatePicker/CalendarContainer";
import CustomDatePicker from "../CustomDatePicker";
import FileInput from "../FileInput";
import CheckBox from "../CheckBox";

import FieldController from "../FieldController";
import Rank from "../Rank";
import Radio from "../Radio";
import ComboBoxMultipleCheckbox from "../ComboBoxMultipleCheckbox";
import Address from "../Address";
import FormFieldArray from "../FormFieldArray";
import ContactArrayComponent from "../ContactArrayComponent";
import AddressField from "../AddressField";
import TreeSelectModalWithSearch from "../TreeSelectModalWithSearch";
import TreeSelectMultiModalWithSearch from "../TreeSelectMultiModalWithSearch";

import SelectTreeAdd from "../SelectTreeAdd";
import TextArea from "../TextArea";
import validate from "./validate";

import Reference from "../Reference";

import store from "store";

import { get, isEqual } from "lodash";

import { DATE_VIEW_FORMAT, DATE_TIME_VIEW_FORMAT } from "./constants";

import { getValueFromStr, getInitialValuesFromWidgets } from "./helpers";

import GridWrapper from "../../../../custom-hooks/GridWrapper";


import "./styles.scss";

const mapStateToProps = (state, ownProps) => {
    return {
        form: ownProps.formName, // set form name from ownProps
        // destroyOnUnmount: "destroyOnUnmount" in ownProps ? ownProps.destroyOnUnmount : true,
        isDestroyOnUnmount: "destroyOnUnmount" in ownProps ? ownProps.destroyOnUnmount : true,
        formValues: getFormValues(ownProps.formName)(state),
        formErrors: getFormSyncErrors(ownProps.formName)(state),
        active: state.form && state.form[ownProps.formName] && state.form[ownProps.formName].active,
        initialValues: state.form[ownProps.formName] && state.form[ownProps.formName].initial,
        regFields: state.form[ownProps.formName] && state.form[ownProps.formName].registeredFields,
        layoutCollapse: state.layoutCollapse
    };
};

const mapDispatchToProps = {
    submitForm: form => submit(form),
    showNotification,
};

const AUTOSAVE_TYPES = ["radio", "fileSingle", "fileMultiple", "rank"];

// contact and selectTreeAdd using "custom local FieldController" due to it's array type
const WIDGETS_WITHOUT_CONTROLLER = [
    "checkbox",
    "checkboxToggle",
    "address",
    "contact",
    "selectTreeAdd",
    "selectTreeModalWithSearch",
    "selectTreeMultiModalWithSearch",
    "customComponent",
    "reference",
];

const WIDGET_STYLE_MAP = {
    "AccentNone": "",
    "AccentBold": "accent-bold",
}

// const WIDGETS_WITH_RIGHT_CONTROLLER_POSITION = ["searchbox", "ajaxCombo", "select", "multiselect", "date", "datetime"];

// TODO: maybe add support of LiveSaver to this widgets later in ui-core, date and datetime need to have updated onBluer behavior
// const WIDGETS_WITH_LOCAL_LIVE_SAVER = [
//     'date',
//     'datetime',
//     'radio',
//     'rank',
//     'fileMultiple',
//     'multiselect',
//     'address',
// ];

/*
    DynamicForm main props:
    1. formName => give DynamicForm custom form name to check it later in store
    2. formValues => used to ref fields work properly (get value of ref field and return options)
    3. liveSave => turns on saving every field on blur/tab/enter/buttons click etc.
    4. mainId => id of main data (used for form collapse manipulation and update useEffect)
    5. currentId => id of current data (used for form collapse manipulation and liveSubmit)
    6. blockOffsetKey => fieldKey to calculate offset and scroll to error if any
    7. setBlockOffset => return offset height to error

*/

// function renderFieldArray

const FieldArrayComponent = props => {
    const {
        t,
        name,
        fields,
        widgets,
        arrayKey,
        renderWidgets,
        formValues,
        disabled,
        onFieldsRemove,
        // meta: { error, name, submitFailed },
    } = props;

    const initValues = widgets.reduce((acc, curr) => {
        let widget = curr;
        if (typeof curr === "function") {
            widget = widget(formValues);
        }
        if (!widget) {
            return acc;
        }
        return {
            ...acc,
            [widget.key]: null,
        };
    }, {});

    function removeFields(index) {
        if (onFieldsRemove && typeof onFieldsRemove === "function") {
            onFieldsRemove(arrayKey, index, initValues);
        }
        fields.remove(index);
    }
    return (
        <>
            {fields.map((field, index) => {
                return (
                    <>
                        {renderWidgets(widgets, arrayKey, index, field)}
                        {!disabled && (
                            <button
                                type="button"
                                className="remove-button add-button"
                                title={t("remove")}
                                onClick={() => removeFields(index)}
                            >
                                <i className="icon-delete" />
                            </button>
                        )}
                    </>
                );
            })}
            {!disabled && (
                <button type="button" className="add-button" title={t("add")} onClick={() => fields.push(initValues)}>
                    + {t("add")}
                </button>
            )}
        </>
    );
};

const DynamicForm = props => {
    const {
        t,
        initialize,
        dynData,
        handleSubmit,
        submitForm,
        initialValues,
        forceInitialValues,
        formName,
        formValues,
        formCollapse,
        className,
        change,
        refreshDynParams,
        setFormCollapse,
        blockOffsetKey,
        setBlockOffset,
        mainId,
        currentId,
        objectId,
        objectTypeSpec,
        objectType, // used for file upload and some ext params request strict typing
        liveSave,
        active,
        liveSaveIdKey = "taskId",
        liveSaveUrlKey = "save_order_param",
        liveSaveJSON = false,
        liveSaveWithoutChangeNum = false,
        formErrors,
        isLiveSaveOnlyValid,
        maxInputLength = 256,
        maxTextAreaLength = 3000,
        setIsLiveSubmitting,
        withoutCollapse = false,
        onLiveSaveSuccess,
        onLiveSaveStart,
        onLiveSaveFinish,
        isOnceInitialized,
        readonly,
        portalPlacement,
        // portalTopLimit,
        // portalBottomLimit,
        // showNotification = () => {},
        showNotification,
        regFields,
        onActions,
        // portalRootId,

        onFieldChange,
        uploadFileSource,
        submitFailed,
        isDestroyOnUnmount,
        deleteFileWithoutRequest,
        maxFileSize,
        isRefreshFormCollapse,
        setIsRefreshFormCollapse,
        confGridObjectType,
        confGridCacheType = 'dynamic-form-conf-grid',
        confGridWithoutFieldsCache,
        confGridWithoutSortCache,
        layoutCollapse, // used in grid mod to cause delay updates
        withAjaxAndFilesExValue, // used in appeal knowledgebase template set, we need that to extend the ajaxCombo and files values with the labels
        isForceHiddenController,
        onAppealDestinationsReload,
        onCustomerProblemReload,
        customSelectPortalClassName,
        isSelectPortalMenuFlexible,
        datePickerPopperPlacement,
    } = props;

    const [collapseState, setCollapseState] = useState({});
    const [ajaxOptions, setAjaxOptions] = useState({});
    const [ajaxInitOptions, setAjaxInitOptions] = useState({});
    const [extOptions, setExtOptions] = useState({});
    const [heights, setHeights] = useState(null);
    const [extOptionsLoading, setExtOptionsLoading] = useState({});
    const [forceDirtyToPristine, setForceDirtyToPristine] = useState({}); // force widget to be not dirty

    const [isForceToSubmit, setIsForceToSubmit] = useState({}); // force widget to auto submitted (support gear click case)
    const [isExtClickLoading, setIsExtClickLoading] = useState({});


    const [resetKeyFields, setResetKeyFields] = useState({});
    const [resetKeySavedValues, setResetKeySavedValues] = useState({});

    const [lastDeletedArrayFieldName, setLastDeletedArrayFieldName] = useState(null);
    const [isConfGridLoading, setIsConfGridLoading] = useState({})

    const enterDisabledTypes = ["multiline"];
    const dynDataLength = dynData.length;

    const refs = useRef(dynData.map(React.createRef));

    const convertOptions = options =>
        !options
            ? []
            : options.map(option => {
                  const advancedData = {};
                  if ("default" in option) {
                      advancedData.default = option.default;
                  }
                  if ("collapsed" in option) {
                      advancedData.collapsed = option.collapsed;
                  }
                  return { label: option.value, value: option.key, default: option.default, ...advancedData };
              });

    const getRefOptions = (options, refValue) => {
        if (!refValue) return convertOptions(options); // return default if not refValue selected;
        const refOptions = convertOptions(options.filter(option => option.refVal && option.refVal.includes(refValue)));
        return refOptions;
    };

    const toggleCollapse = key => {
        const widgetsCollapsed = { ...collapseState }; // spread to clone collapseObj
        widgetsCollapsed[key] = !widgetsCollapsed[key]; // toggle value by key
        setCollapseState(widgetsCollapsed);
    };

    const handleSelectInputChange = (searchStr, attributeKey,  blockKey, widget, clearOnEmpty) => {
        change(`${attributeKey}CreatableInput`, searchStr);
    };

    const setOptionsQuery = debounce((searchStr, attributeKey, blockKey, widget, clearOnEmpty) => {
        const initOptions = ajaxInitOptions[attributeKey] || [];
        if (!searchStr && clearOnEmpty) {
            setAjaxOptions(ajaxOptions => ({
                ...ajaxOptions,
                [attributeKey]: [],
            }));
            if (!isDestroyOnUnmount) {
                change(`${attributeKey}_cached_ajax_options`, initOptions);
            }
            return;
        }
        if (!searchStr || searchStr.length < 2) {
            if (!isDestroyOnUnmount) {
                setAjaxOptions(ajaxOptions => ({
                    ...ajaxOptions,
                    [attributeKey]: [],
                }));
            }
            return;
        }

        const optionsCallback = newOptions => {
            const mergedWithInitOptions = [...newOptions, ...initOptions];
            setAjaxOptions(ajaxOptions => ({
                ...ajaxOptions,
                [attributeKey]: mergedWithInitOptions,
            }));
            // in case of no initOptions provided, and !destroyOnUnmount => set _cached_ajax_options
            // if (initOptions.length === 0 && !isDestroyOnUnmount) {
            // in case of !destroyOnUnmount => set _cached_ajax_options with init options
            if (!isDestroyOnUnmount) {
                change(`${attributeKey}_cached_ajax_options`, mergedWithInitOptions);
            }
        };
        // handle customAjaxOptions
        if (widget.customAjaxOptions && typeof widget.customAjaxOptions === "function") {
            widget.customAjaxOptions(searchStr, optionsCallback, attributeKey, formValues, widget);
            return;
        }
        // handle default ajax
      
        const params =
        widget?.customAjaxParams && typeof widget.customAjaxParams === "function"
            ? widget.customAjaxParams(searchStr, attributeKey, blockKey, widget, clearOnEmpty)
            : {
                data: { attributeKey, blockKey, searchStr, page: 1, start: 0, limit: 25 },
            };
        const queryMethod = widget?.customAjaxMethod || "post";
        const queryKey = widget?.customAjaxKey || "appeal_form_ajax";
        baseService[queryMethod](queryKey, params).then(({ success, result }) => {
            if (success) {
                const newOptions =
                widget?.customAjaxOptionsConverter && typeof widget.customAjaxOptionsConverter === "function"
                    ? convertOptions(widget.customAjaxOptionsConverter(result))
                    : convertOptions(result);
                
                optionsCallback(newOptions);
            } else {
                console.log("Ajax options request failed");
            }
        });
        if (widget?.isCreatable) {
            change(`${attributeKey}CreatableInput`, searchStr);
        }
    }, 300);

    const getBlockVersionByField = key => {
        let version = null;
        dynData.forEach(block => {
            block.widgets.forEach(widget => {
                if (widget.key === key) {
                    version = block.version;
                }
            });
        });
        return version;
    };

    const checkDynDataForExt = fieldKey => {
        let isExt = false;
        dynData.forEach(block =>
            block.widgets.forEach(widget => {
                if (widget.key === fieldKey && widget.rule === "#[callMethod]") isExt = true;
            })
        );
        return isExt;
    };

    // simplified logic - simply set last deletedArrayFieldName and prevent from clearing not equal values of such reset field
    const handleFieldsRemove = (name, index, initValues) => {
        setLastDeletedArrayFieldName(`${name}[`);
    };

    const getExtValue = fieldKey => {
        let extValue = "";
        const { options } = extOptions[fieldKey];
        const selectedOption = options.filter(option => +option.value === +formValues[fieldKey])[0];
        extValue = selectedOption && selectedOption.value ? `${selectedOption.label}:${selectedOption.value}` : "";
        return extValue;
    };

    const handleLiveSubmit = customLiveSubmit => (key, responseCallback, isStringifyAttrValue, batchValues) => {
        let widget;
        dynData.forEach(block => {
            block.widgets.forEach(item => {
                if (item.key === key) {
                    widget = item;
                }
            });
        });
        if (isLiveSaveOnlyValid && formErrors && formErrors[key]) {
            const valueToSave = formValues[key];
            const isEmptyValue = typeof valueToSave === "object" ? isEmpty(valueToSave) : [null, undefined, ""].includes(valueToSave);
            // we should able to submit required widget with an empty value (UI will still show the validation error, but the value will be saved)
            const isEmptyRequiredWidget = widget && widget.isReq && isEmptyValue;
            if (!isEmptyRequiredWidget) {
                // in other cases validation should prevent from saving a non valid value
                responseCallback(false);
                return;
            }
        }
        const isExtField = checkDynDataForExt(key);
        const blockVersion = getBlockVersionByField(key);
        let urlKey = liveSaveUrlKey;
        let data = {
            data: {
                [liveSaveIdKey]: currentId,
                attrCode: key,
                attrValue: isExtField ? getExtValue(key) : formValues[key] || "",
            },
            jsonType: liveSaveJSON,
            batchValues,
        };
        if (batchValues) {
            data.batchValues = batchValues;
        }
        if (isStringifyAttrValue) {
            data.data.attrValue = JSON.stringify(data.data.attrValue);
        }

        let customChangeNum;
        let method = "post";
        if (customLiveSubmit && typeof customLiveSubmit === "function") {
            const bindedValues = {};
            const bindedKeys = widget && widget.bindedValuesKeys;
            if (bindedKeys && Array.isArray(bindedKeys)) {
                bindedKeys.forEach(key => {
                    bindedValues[key] = formValues[key]
                })
            }
            const customData = customLiveSubmit(data, bindedValues);
            if (!customData) {
                // prevent from submit if no customData returned.
                responseCallback(false, true); // arguments: success, isFromResponse (if isFromResponse - we will fallback to init val)
                return;
            }
            if (customData && customData.data) {
                data = customData.data;
            }
            if (customData && customData.liveSaveUrlKey) {
                urlKey = customData.liveSaveUrlKey;
            }
            if (customData && customData.changeNum) {
                customChangeNum = customData.changeNum;
            }
            if (customData && customData.method) {
                method = customData.method;
            }
        }

        if (!liveSaveWithoutChangeNum) {
            data.data.changeNum = customChangeNum || blockVersion ;
        }

        if (setIsLiveSubmitting && typeof setIsLiveSubmitting === "function") {
            setIsLiveSubmitting(true);
        }
        if (onLiveSaveStart && typeof onLiveSaveStart === "function") {
            onLiveSaveStart({ urlKey, data, key });
        }
        baseService[method](urlKey, data)
            .then((response) => {
                const { success, result } = response
                if (onLiveSaveFinish && typeof onLiveSaveFinish === "function") {
                    onLiveSaveFinish({ urlKey, data, key });
                }
                responseCallback(success, true); // arguments: success, isFromResponse
                if (setIsLiveSubmitting && typeof setIsLiveSubmitting === "function") {
                    setIsLiveSubmitting(false);
                }
                if (success) {
                    // check for dynParams refresh
                    let actions = result && result.actions;

                    if (result && Array.isArray(result)) {
                        // handle array of results => combine an actions here
                        const combinedActions = result.flatMap(item => item ? item.actions : [])
                        if (combinedActions.length > 0) {
                            actions = combinedActions
                        }
                    }
                    
                    if (actions && Array.isArray(actions)) {
                        actions.forEach((object) => {
                            if (object && typeof object === 'object' && "action" in object) {
                                switch (object.action) {
                                    case 'appealDestinationsReload':
                                        if (typeof onAppealDestinationsReload === 'function') {
                                            onAppealDestinationsReload();
                                        }
                                        break;
                        
                                    case 'customerProblemReload':
                                        if (typeof onCustomerProblemReload === 'function') {
                                            onCustomerProblemReload(currentId);
                                        }
                                        break;
                        
                                    case 'displayAttr':
                                        change(object.key, object.value);
                                        break;
                        
                                    case 'formReload':
                                        if (refreshDynParams && typeof refreshDynParams === 'function') {
                                            refreshDynParams();
                                        }
                                        break;
                        
                                    default:
                                        break;
                                }
                            } else {
                                console.log(`DynamicForm::handleLiveSubmit: action ${object} is not an object`);
                            }
                        });
                    }
                    
                    if (onLiveSaveSuccess && typeof onLiveSaveSuccess === "function") {
                        // console.log({result, data});
                        onLiveSaveSuccess({
                            result,
                            data,
                            extOptions: extOptions[key],
                            ajaxOptions: ajaxOptions[key],
                            urlKey,
                        });
                    }
                } else {
                    console.error("Save param request failed, response: ", response);
                    if (onLiveSaveFinish && typeof onLiveSaveFinish === "function") {
                        onLiveSaveFinish({ urlKey, data, key });
                    }
                    if (setIsLiveSubmitting && typeof setIsLiveSubmitting === "function") {
                        setIsLiveSubmitting(false);
                    }
                }
            })
            .catch(e => {
                if (onLiveSaveFinish && typeof onLiveSaveFinish === "function") {
                    onLiveSaveFinish({ urlKey, data, key });
                }
                if (setIsLiveSubmitting && typeof setIsLiveSubmitting === "function") {
                    setIsLiveSubmitting(false);
                }
                console.error("DynamicForm::handleLiveSubmit: Error:", e);
            });
    };

    const handleFileUpload = (file, handleUploadResponse, inputKey, onConditionFileUpload, widgetUploadFileSource) => {
        const data = {
            data: {
                data: {
                    objectId: objectId || +currentId,
                    objectType: objectType || "TASK",
                    fileName: file.name,
                    attrCode: inputKey,
                },
                file,
            },
            file: true,
        };
        const fileSource = widgetUploadFileSource || uploadFileSource;
        // source=form payload param should be added in case files are being uploaded via dynamic params
        // to distinguish the file upload source
        if (fileSource) {
            data.data.data.source = fileSource;
        }
        return baseService
            .post("save_file", data)
            .then(({ success, result }) => {
                if (success) {
                    // in case of !destroyOnUnmount => set _cached_file_values and update inputKey files (to keep values in unmouned state)
                    if (!isDestroyOnUnmount) {
                        // get formValues in such way, because component "formValues" props could be outdated and stale
                        // due to unmounted component
                        const state = store.getState();
                        const formValues = state && state.form && state.form[formName] && state.form[formName].values;
                        if (result) {
                            const prevCachedFiles = formValues[`${inputKey}_cached_file_values`] || [];
                            const uploadedFile = { key: result.id, value: result.fileName };
                            const mergedCachedFiles = [uploadedFile, ...prevCachedFiles];
                            change(`${inputKey}_cached_file_values`, mergedCachedFiles);
                        }
                        const prevValue = formValues && formValues[inputKey];
                        let prevFiles = [];
                        if (prevValue) {
                            if (typeof prevFiles === "string") {
                                prevFiles = [prevValue];
                            }
                            if (Array.isArray(prevValue)) {
                                prevFiles = prevValue;
                            }
                        }
                        const newFiles = [result.id, ...prevFiles];
                        change(inputKey, newFiles);
                    }
                    handleUploadResponse(file, result.id || result, "", onConditionFileUpload);
                } else {
                    console.log("Uploading file request failed");
                    handleUploadResponse(file, null, "Error during file upload");
                }
            })
            .catch(e => {
                console.log("Uploading file request failed", e);
                handleUploadResponse(file, null, "Error during file upload");
            });
    };

    const handleFileDelete = (fileId, handleDeleteResponse) => {
        if (deleteFileWithoutRequest) {
            handleDeleteResponse(fileId);
        } else {
            const data = { data: { fileId } };
            baseService.post("delete_file", data).then(({ success }) => {
                if (success) {
                    handleDeleteResponse(fileId);
                } else {
                    console.log("Delete file request failed");
                    handleDeleteResponse(fileId, "Error during file delete");
                }
            });
        }
    };

    const getViewClass = view => {
        switch (view) {
            case "2column": {
                return "two-column";
            }
            case "3column": {
                return "three-column";
            }
            case "4column": {
                return "four-column";
            }
            case "grid_mod": {
                return "grid-mod";
            }
            default: {
                return "form";
            }
        }
    };

    // savedFiles in format: "key|key"
    // fileValues in format [{key, value}]
    // cachedFileValues in format [{key, value}]
    // cachedFileValues is currently used to handle file upload from kb
    const getUploadedFiles = (formSavedFiles = [], fileValues, cachedFileValues) => {
        let savedFiles;
        if (formSavedFiles && Array.isArray(formSavedFiles)) {
            savedFiles = formSavedFiles.map(file => {
                if (typeof file === "object") {
                    // get either id or key to make an array [{fileId}];
                    return file.id || file.key;
                }
                return file;
            });
        }
        let mergedValues = [];
        if (fileValues) {
            mergedValues = [...mergedValues, ...fileValues];
        }
        if (cachedFileValues) {
            mergedValues = [...mergedValues, ...cachedFileValues];
        }
        if (!savedFiles || savedFiles.length === 0) return [];

        if (cachedFileValues && cachedFileValues.length > 0) {
            // find unique files (to prevent duplicates due to cachedFileValues)
            const mergedKeys = mergedValues.map(val => val.key);
            mergedValues = [...new Set(mergedKeys)].map(key => mergedValues.find(val => val.key === key));
        }
        const uploadedFiles = mergedValues.filter(value => savedFiles.includes(value.key));
        return uploadedFiles;
    };

    const updateExtOptions = (fieldKey, newOptions) => {
        const field = extOptions[fieldKey];
        const { initialOptions, refKey } = field;
        const refValue = formValues[refKey];
        setExtOptions(options => ({
            ...options,
            [fieldKey]: {
                ...options[fieldKey],
                savedRefValue: refValue,
                options: newOptions || initialOptions,
            },
        }));
    };

    const handleFieldChange = (fieldAjaxOptionsToResetOnChange, ...args) => {
        if (onFieldChange && typeof onFieldChange === "function") {
            onFieldChange(...args);
        }
        if (fieldAjaxOptionsToResetOnChange) {
            // since we are reseting options we have to reset it dirty state as well
            setForceDirtyToPristine(keys => ({ ...keys, [fieldAjaxOptionsToResetOnChange]: true }));
            setAjaxInitOptions(options => ({
                ...options,
                [fieldAjaxOptionsToResetOnChange]: [],
            }));
            setAjaxOptions(ajaxOptions => ({
                ...ajaxOptions,
                [fieldAjaxOptionsToResetOnChange]: [],
            }));
        }
    };

    const handleExtParamsRequest = (fieldKey, params) => {
        baseService.post("get_external_params", params).then(({ success, result }) => {
            setExtOptionsLoading(extOptionsLoading => ({
                ...extOptionsLoading,
                [fieldKey]: false,
            }));
            if (success) {
                if (!isEmpty(result[fieldKey][0])) {
                    const resultOptions = result[fieldKey].map(option => ({
                        label: option.id,
                        value: option.value,
                    }));
                    updateExtOptions(fieldKey, resultOptions);
                }
            } else {
                console.log("External / REST options request failed");
            }
        });
    };

    const getSelectedExtOption = fieldKey => {
        const extFieldOptions = extOptions[fieldKey].options;
        const extFieldValue = formValues[fieldKey];
        return extFieldOptions.filter(option => option.value === extFieldValue)[0];
    };

    const getDirtyExtVals = () => {
        let obj = {};
        Object.keys(formValues).map(key => {
            if (extOptions[key]) {
                const selectedOption = getSelectedExtOption(key);
                obj = {
                    ...obj,
                    [key]:
                        selectedOption && selectedOption.value
                            ? `${selectedOption.label}:${selectedOption.value}`
                            : null,
                };
            }
        });
        return obj;
    };

    const getExtFilterRefVal = fieldKey => {
        if (extOptions[fieldKey] && extOptions[fieldKey].refKey) {
            const { refKey } = extOptions[fieldKey];
            if (extOptions[refKey]) {
                const selectedOption = getSelectedExtOption(refKey);
                return selectedOption && selectedOption.label;
            }
            return formValues[refKey];
        }
    };

    const handleExtSelectOpen = fieldKey => {
        setExtOptionsLoading(extOptionsLoading => ({ ...extOptionsLoading, [fieldKey]: true }));
        const params = {
            data: {
                dirtyVals: { ...formValues, ...getDirtyExtVals() },
                filterVal: getExtFilterRefVal(fieldKey) || formValues[fieldKey],
                objectId: objectId || currentId,
                objectType: objectType || "task",
                objectTypeSpec,
                objectVal: null,
                paramId: fieldKey,
            },
            jsonType: true,
        };
        handleExtParamsRequest(fieldKey, params);
    };

    // reset ref/extRef fields if parent field changed
    const handleExtRefChange = (fieldKey, refKey, rule) => {
        const currentValue = formValues[fieldKey];
        const currentRefValue = formValues[refKey];
        const { savedRefValue, initialOptions } = extOptions[fieldKey];
        const isExt = rule === "#[callMethod]";

        const isEmptySaved = [null, undefined, ""].includes(savedRefValue);
        const isEmptyCurrent = [null, undefined, ""].includes(currentRefValue);
        const isSavedOrCurrNotEmpty = !isEmptySaved || !isEmptyCurrent;

        const isEmptyCurrentValue = [null, undefined, ""].includes(currentValue);

        if (isSavedOrCurrNotEmpty && savedRefValue !== currentRefValue) {
            // handle case for changing ref field while current value is not selected yet => update ext options
            if (isEmptyCurrentValue) {
                if (isExt) {
                    updateExtOptions(fieldKey, []);
                } else {
                    updateExtOptions(fieldKey, getRefOptions(initialOptions, currentRefValue));
                }
                return;
            }
            // handle case when current value was selected and should be cleared up
            if (isExt) {
                change(fieldKey, "");
                if (savedRefValue) {
                    setForceDirtyToPristine(keys => ({ ...keys, [fieldKey]: true }));
                }
                updateExtOptions(fieldKey, []);
            } else {
                // additional check for ref options
                const refOptions = convertOptions(
                    initialOptions.filter(option => option.refVal && option.refVal.includes(currentRefValue))
                );
                const refValues = refOptions.map(option => option.value);
                // case: curValue is 10, refValue changed so curValue 10 is not matching any options ('1', '2', '3')
                if (refOptions.length !== 0 && !refValues.includes(currentValue)) {
                    change(fieldKey, "");
                    setForceDirtyToPristine(keys => ({ ...keys, [fieldKey]: true }));
                }
                // case: refValue is empty and currentValue is filled - cleared up
                if (
                    refValues.length === 0 &&
                    ![null, undefined, ""].includes(currentValue) &&
                    [null, undefined, ""].includes(currentRefValue)
                ) {
                    change(fieldKey, "");
                    setForceDirtyToPristine(keys => ({ ...keys, [fieldKey]: true }));
                }
                updateExtOptions(fieldKey, getRefOptions(initialOptions, currentRefValue));
            }
        }
    };

    // 'label:label:label:value' => 'label:label:label'
    const getLabelFromStr = stringValue => {
        if (!stringValue) return null;
        const arrayValue = stringValue.split(":");
        return arrayValue.slice(0, arrayValue.length - 1).join(":"); // get all accept last value and join it into string
    };

    const convertExtValues = values =>
        values.map(val => ({
            value: getValueFromStr(val.key),
            label: getLabelFromStr(val.value),
        }));

    // handle convert back string value into timestamp
    const handleDatePickerChange = ({ type, value, key }) => {
        const format = type === "datetime" ? DATE_TIME_VIEW_FORMAT : DATE_VIEW_FORMAT;

        const isValid = moment(value, format).format(format) === value;
        if (isValid) {
            const unixTS = moment(value, format).unix();
            setTimeout(() => change(key, `${unixTS * 1000}`), 0);
        }
    };

    const processResetWidgetKey = (resetKey, widgetKey) => {
        const resetFields = get(resetKeyFields, resetKey, []);
        if (!resetFields.includes(widgetKey)) {
            setResetKeyFields(prev => {
                const prevFields = get(prev, resetKey, []);
                return {
                    ...prev,
                    [resetKey]: [...prevFields, widgetKey],
                };
            });
        }
    };

    const renderField = data => {
        const {
            widgetType,
            key: widgetKey,
            blockKey,
            title,
            isReq,
            values,
            refKey,
            savedValue,
            rule,
            clearable,
            maxLength,
            handleContactChange,
            inputType = "text",
            hasExValue,
            extensions,
            resetKey,
            isUploadByCondition,
            uploadCondition,
            onConditionFileUpload,
            withMarkdown,
            autosize,
            minDateKey,
            maxDateKey,
            withSearch,
            withAsyncSearch,
            customLiveSubmit,
            isCreatable,
            fieldAjaxOptionsToResetOnChange,
        } = data;

        const isExt = rule === "#[callMethod]";

        const disabled = readonly || data.disabled;

        const key = widgetKey;

        if (resetKey) {
            if (Array.isArray(resetKey)) {
                resetKey.forEach(resKey => processResetWidgetKey(resKey, widgetKey));
            } else {
                processResetWidgetKey(resetKey, widgetKey);
            }
        }

        const defaultProps = {
            key,
            name: key,
            label: title,
            disabled,
            required: isReq,
            rule,
            clearable,
            hasExValue,
            withMarkdown,
            showNotification,
            widgetType,
            withSearch,
            onFieldChange,
            customSelectPortalClassName,
            isSelectPortalMenuFlexible,
        };

        if (fieldAjaxOptionsToResetOnChange || (onFieldChange && typeof onFieldChange === "function")) {
            defaultProps.onChange = (...args) => handleFieldChange(fieldAjaxOptionsToResetOnChange, ...args);
        }

        // additional disabled props to make input scrollable in disabled state
        const disabledInputProps = disabled ? { input: { value: (formValues && formValues[key]) || "" } } : {};

        // Parse the rule string to extract min and max dates
        let ruleMinDate, ruleMaxDate = null;
        if (["date", "datetime"].includes(widgetType) && rule && typeof rule === 'string') {
            const parseRule = (rule) => {
                let parsedRuleMinDate = null;
                let parsedRuleMaxDate = null;
            
                // Check if the rule exists and is a valid string
                const ruleParts = rule.split('|');
                // console.log({ruleParts});
                ruleParts.forEach((part) => {
                    const [key, value] = part.split(':');
                    if (key === 'MIN' && !isNaN(+value)) {
                        parsedRuleMinDate = moment(+value); // Convert timestamp to moment
                    } else if (key === 'MAX' && !isNaN(+value)) {
                        parsedRuleMaxDate = moment(+value); // Convert timestamp to moment
                    }
                });
            
                return { parsedRuleMinDate, parsedRuleMaxDate };
            };
            
            // Get ruleMinDate and ruleMaxDate from the rule
            const { parsedRuleMinDate, parsedRuleMaxDate } = parseRule(rule);
            ruleMinDate = parsedRuleMinDate;
            ruleMaxDate = parsedRuleMaxDate;
            // if (ruleMinDate || ruleMaxDate) {
            //     console.log({
            //         ruleMinDate:
            //             parsedRuleMinDate &&
            //             parsedRuleMinDate.format(widgetType === "date" ? DATE_VIEW_FORMAT : DATE_TIME_VIEW_FORMAT),
            //         ruleMaxDate:
            //             parsedRuleMaxDate &&
            //             parsedRuleMaxDate.format(widgetType === "date" ? DATE_VIEW_FORMAT : DATE_TIME_VIEW_FORMAT),
            //     });
            // }
        }

        // Default props for date picker
        const defaultPropsDate = {
            saveFormat: "x",
            locale: "uk",
            popperContainer: (props) => <CalendarContainer {...props} fieldKey={key} />,
            showMonthDropdown: true,
            showYearDropdown: true,
            minDate: minDateKey && formValues[minDateKey]
                ? moment(+formValues[minDateKey]) // Use form value if available
                : ruleMinDate, // Fallback to rule minDate (null if not parsed)
            maxDate: maxDateKey && formValues[maxDateKey]
                ? moment(+formValues[maxDateKey]) // Use form value if available
                : ruleMaxDate, // Fallback to rule maxDate (null if not parsed)
            touch: props.touch && typeof props.touch === 'function' ? (key) => props.touch(formName, key) : null
        };
        

        // either get _cached_ajax_options, or get initOptions
        const initAjaxOptions =
            formValues &&
            formValues[`${key}_cached_ajax_options`] &&
            formValues[`${key}_cached_ajax_options`].length > 0
                ? formValues[`${key}_cached_ajax_options`]
                : ajaxInitOptions[key];
        const defaultPropsAjax = {
            placeholder: t("searchPhrase"),
            openOnClick: false,
            options: ajaxOptions[key] && ajaxOptions[key].length ? ajaxOptions[key] : initAjaxOptions,
            onInputChange: query => setOptionsQuery(query, key, blockKey, data),
            filterOption: () => true, // options are filtered already by string on backend side, return all options by default
            noResultsText: t("noItems"),
            clearable,
            searchable: true,
        };

        let defaultPropsTreeModalWithSearch = {};

        if (widgetType === "selectTreeModalWithSearch") {
            defaultPropsTreeModalWithSearch = {
                placeholder: data.placeholder || t("placeholderSelectTreeModalWithSearch"),
                initNodeArray: data.initNodeArray,
                nodeArrayApiKey: data.nodeArrayApiKey, // "appeal_type",
                nodeArrayResultKey: data.nodeArrayResultKey, // "children",
            };
        }

        let defaultPropsTreeMultiModalWithSearch = {};

        if (widgetType === "selectTreeMultiModalWithSearch") {
            defaultPropsTreeMultiModalWithSearch = {
                placeholder: data.placeholder || t("placeholderSelectTreeModalWithSearch"),
                options: data.options,
                // selectedOptions: formValues[key] || [],
                tree: true,
                valueField: data.valueField,
                keySelectField: data.keySelectField,
                leafField: data.leafField,
                customAjaxOptions: data.customAjaxOptions,
            };
        }

        let defaultPropsSelectTreeAdd = {};

        if (widgetType === "selectTreeAdd") {
            defaultPropsSelectTreeAdd = {
                placeholder: data.placeholder || t("placeholderSelectTreeAdd"),
                options: data.options,
                unlockAppealForm: data.unlockAppealForm,
                onFieldRemove: data.onFieldRemove,
                additionDisabled: data.additionDisabled,
                isLoading: data.isLoading,
            };
        }

        let onDatePickerChange;
        if (["date", "datetime"].includes(widgetType)) {
            onDatePickerChange = (value, ...rest) => {
                if (defaultProps.onChange && typeof defaultProps.onChange === "function") {
                    defaultProps.onChange(value, ...rest);
                }
                return handleDatePickerChange({ type: widgetType, value, key });
            };
        }

        switch (widgetType) {
            case "input": {
                return (
                    <Field
                        {...defaultProps}
                        {...disabledInputProps}
                        className={cx("input-field", { disabled })}
                        disabled={false} // always false, disable typing by class and disabledInpusProps
                        spellCheck={false} // remove red hightlight
                        maxLength={maxLength || maxInputLength}
                        type={inputType}
                        component={Input}
                    />
                );
            }
            case "select": {
                const onMenuOpen = data.onOpen && typeof data.onOpen === 'function' ? data.onOpen : null;
                return (
                    <Field
                        {...defaultProps}
                        placeholder={t("dontSelect")}
                        noResultsText={t("noItems")}
                        clearValueText={t("clearValue")}
                        options={
                            refKey || rule === "#[callMethod]"
                                ? (extOptions[key] && extOptions[key].options) || []
                                : convertOptions(values)
                        }
                        onInputChange={isCreatable ? (query) => handleSelectInputChange(query, key, blockKey, data, false) : null}
                        onOpen={isExt ? () => handleExtSelectOpen(key) : null}
                        onMenuOpen={onMenuOpen}
                        disabled={disabled || (isExt && refKey && formValues && !formValues[refKey])} // disabled check for ext ref selects
                        isLoading={extOptionsLoading[key]}
                        escapeClearsValue={!liveSave}
                        onBlurResetsInput={!isCreatable}
                        onCloseResetsInput={!isCreatable}
                        inputProps={data.inputProps || {}}
                        component={ComboBox}
                        svgIconPath={data.svgIconPath}
                        withCollapsedOptions={data.withCollapsedOptions}
                    />
                );
            }
            case "searchbox":
            case "ajaxCombo": {
                return (
                    <Field
                        {...defaultProps}
                        {...defaultPropsAjax}
                        onBlurResetsInput={!isCreatable}
                        onCloseResetsInput={!isCreatable}
                        escapeClearsValue={!liveSave}
                        hasExValue={withAjaxAndFilesExValue || hasExValue}
                        isAsync
                        component={ComboBox}
                    />
                );
            }
            case "multiline": {
                return (
                    <Field
                        {...defaultProps}
                        textAreaClassName={data.textAreaClassName}
                        autosize={autosize}
                        maxLength={maxLength || maxTextAreaLength}
                        component={TextArea}
                        />
                );
            }
            case "date": {
                return (
                    <Field
                        {...defaultProps}
                        {...defaultPropsDate}
                        viewFormat={DATE_VIEW_FORMAT}
                        yearDropdownItemNumber={10}
                        hasTimePicker={false}
                        popperPlacement={datePickerPopperPlacement}
                        onChange={onDatePickerChange}
                        component={CustomDatePicker}
                    />
                );
            }
            case "datetime": {
                let minTime;
                let maxTime;
                // this logic was used a while ago with the related date widgets (from / to)
                // let's keep it here and only apply it if we have minDateKey or maxDateKey (related fields)
                if (minDateKey || maxDateKey) {
                    const { minDate, maxDate } = defaultPropsDate;
                    const currentDate = formValues[key] && moment(+formValues[key]);
                    // minDate => widget "to" currentDate => "toDate"
                    if (minDate && currentDate) {
                        const isSameDay = minDate.isSame(currentDate, "day");
                        if (isSameDay) {
                            minTime = minDate.add(1, "minutes");
                            maxTime = currentDate.clone().endOf("day");
                        }
                    }
                    // maxDate => widget "from", currentDate => "fromDate"
                    if (maxDate && currentDate) {
                        const isSameDay = maxDate.isSame(currentDate, "day");
                        if (isSameDay) {
                            minTime = currentDate.clone().startOf("day");
                            maxTime = maxDate.add(1, "minutes");
                        }
                    }
                }
                return (
                    <Field
                        {...defaultProps}
                        {...defaultPropsDate}
                        viewFormat={DATE_TIME_VIEW_FORMAT}
                        yearDropdownItemNumber={10}
                        minTime={minTime}
                        maxTime={maxTime}
                        popperPlacement={datePickerPopperPlacement}
                        onChange={onDatePickerChange}
                        component={CustomDatePicker}
                    />
                );
            }
            case "radio": {
                return <Field {...defaultProps} values={values} component={Radio} />;
            }
            case "rank": {
                return <Field {...defaultProps} values={values} component={Rank} />;
            }
            case "multiselect": {
                let onMultiSelectOpen = isExt ? () => handleExtSelectOpen(key) : null;
                if (!onMultiSelectOpen && data.onOpen && typeof data.onOpen === "function") {
                    onMultiSelectOpen = data.onOpen;
                }
                let options = [];
                if (data.customAjaxOptions) {
                    options = ajaxOptions[key] && ajaxOptions[key].length ? ajaxOptions[key] : initAjaxOptions;
                } else {
                    options =
                        refKey || rule === "#[callMethod]"
                            ? (extOptions[key] && extOptions[key].options) || []
                            : convertOptions(values);
                }

                return (
                    <Field
                        {...defaultProps}
                        placeholder={t("dontSelect")}
                        noResultsText={t("noItems")}
                        clearValueText={t("clearValue")}
                        initialValues={initialValues && initialValues[key]}
                        options={options}
                        onInputChange={query => setOptionsQuery(query, key, blockKey, data, true)}
                        onOpen={onMultiSelectOpen}
                        disabled={disabled || (isExt && refKey && formValues && !formValues[refKey])} // disabled check for ext ref selects
                        isLoading={extOptionsLoading[key] || data.isLoading}
                        escapeClearsValue={!liveSave}
                        isAsync={data.customAjaxOptions}
                        component={ComboBoxMultipleCheckbox}
                        multi
                        withAsyncSearch={withAsyncSearch}
                        onMenuClose={() => setOptionsQuery("", key, blockKey, data, true)}
                    />
                );
            }
            // fileMultiple
            case "fileMultiple": {
                return (
                    <Field
                        {...defaultProps}
                        t={t}
                        translate={{
                            size: t("files.size"),
                            maxSize: t("files.maxSize"),
                            ext: t("files.ext"),
                            extAllowed: t("files.extAllowed"),
                            button: t("add"),
                            attention: t("files.attention"),
                            confirmText: t("files.confirmText"),
                            yes: t("files.yes"),
                            no: t("files.no"),
                        }}
                        maxFileSize={maxFileSize || data.maxSize || 25}
                        extensions={[]}
                        handleUpload={handleFileUpload}
                        handleDelete={handleFileDelete}
                        loader={<Loader loaderContainerClass="container-loader" loaderClass="input-loader" />}
                        files={getUploadedFiles(
                            formValues[key] || savedValue,
                            values,
                            formValues[`${key}_cached_file_values`]
                        )}
                        path="../mw/file?fileId="
                        multiple
                        isStringifyAttrValue
                        entityId={objectId || +currentId}
                        hasExValue={withAjaxAndFilesExValue || hasExValue}
                        component={FileInput}
                    />
                );
            }

            case "fileSingle": {
                return (
                    <Field
                        {...defaultProps}
                        t={t}
                        translate={{
                            size: t("files.size"),
                            maxSize: t("files.maxSize"),
                            ext: t("files.ext"),
                            extAllowed: t("files.extAllowed"),
                            button: t("add"),
                            attention: t("files.attention"),
                            confirmText: t("files.confirmText"),
                            yes: t("files.yes"),
                            no: t("files.no"),
                        }}
                        maxFileSize={maxFileSize || data.maxSize || 25}
                        extensions={extensions || []}
                        handleUpload={handleFileUpload}
                        handleDelete={handleFileDelete}
                        loader={<Loader loaderContainerClass="container-loader" loaderClass="input-loader" />}
                        files={getUploadedFiles(
                            formValues[key] || savedValue,
                            values,
                            formValues[`${key}_cached_file_values`]
                        )}
                        path="../mw/file?fileId="
                        isUploadByCondition={isUploadByCondition}
                        uploadCondition={uploadCondition}
                        onConditionFileUpload={onConditionFileUpload}
                        isStringifyAttrValue
                        entityId={objectId || +currentId}
                        hasExValue={withAjaxAndFilesExValue || hasExValue}
                        component={FileInput}
                    />
                );
            }

            case "checkbox": {
                return <Field {...defaultProps} component={CheckBox} />;
            }
            case "checkboxToggle": {
                return <Field {...defaultProps} component={CheckBoxToggle} />;
            }
            case "address": {
                return (
                    <Field
                        {...defaultProps}
                        customClassName="max-4-rows"
                        customerId={data.customerId}
                        customerType={data.customerType}
                        value={savedValue}
                        savedValue={savedValue}
                        component={AddressField}
                    />
                );
            }

            case "contact": {
                return (
                    <FormFieldArray
                        {...defaultProps}
                        errors={formErrors[key]}
                        readOnly={disabled}
                        isSaveOnlyValid={isLiveSaveOnlyValid}
                        handleChangeValue={handleContactChange}
                        component={ContactArrayComponent}
                    />
                );
            }

            case "selectTreeModalWithSearch": {
                return (
                    <Field
                        {...defaultProps}
                        {...defaultPropsTreeModalWithSearch}
                        component={TreeSelectModalWithSearch}
                    />
                );
            }

            case "selectTreeMultiModalWithSearch": {
                return (
                    <Field
                        {...defaultProps}
                        {...defaultPropsTreeMultiModalWithSearch}
                        multi
                        component={TreeSelectMultiModalWithSearch}
                    />
                );
            }

            case "selectTreeAdd": {
                return (
                    <FormFieldArray
                        isSaveOnlyValid={isLiveSaveOnlyValid}
                        {...defaultProps}
                        {...defaultPropsSelectTreeAdd}
                        component={SelectTreeAdd}
                    />
                );
            }

            case "date-dropdown": {
                return (
                    <div>date-dropdown</div>
                    // <Field
                    //     {...defaultProps}
                    //     {...defaultPropsTreeMultiModalWithSearch}
                    //     multi
                    //     component={TreeSelectMultiModalWithSearch}
                    // />
                );
            }

            case "customComponent": {
                const Component = data && data.component;
                if (Component) {
                    return <Component />;
                }
                return null;
            }
            case "conf_grid": {
                if (!rule) {
                    console.log("conf_grid: ATTENTION! External Grid Rule is null!");
                    console.log("conf_grid: widget data ", data);
                    return null;
                }
                const [source, gridConfig] = rule.split(".");
                const extra = `${confGridCacheType}_conf_grid_${currentId}_${widgetKey}`;
                const urlKey = "proxy_grid";
                const init = () => {
                    const data = {
                        key: urlKey,
                        method: "post",
                        configUrlKey: "config_grid",
                        configCode: gridConfig,
                        configKey: source,
                        limit: 100,
                        filterObject: [],
                        sort: [],
                        expanderSource: source,
                        expanderUrlKey: "get_proxy_detail_in_grid",
                        expanderActionsUrlKey: "get_proxy_detail_actions_in_grid",
                        pathParams: {
                            dataSource: source,
                            objectType: confGridObjectType,
                            objectID: currentId,
                        },
                        extra,
                    };
                    return data;
                };

                const fieldsLsCacheKey = `${urlKey}_${gridConfig}`;

                const sortFieldsLsCacheKey = `${urlKey}_${extra}`;

                return (
                    <div className="content-wrapper with-fixed-status dynform-grid-wrapper grid-nohover">
                        {isConfGridLoading[widgetKey] && <Loader />}
                        <GridWrapper
                            tuner={init}
                            initUpdate={false}
                            onStart={() => setIsConfGridLoading(prev => ({ ...prev, [widgetKey]: true }))}
                            onFinish={() => setIsConfGridLoading(prev => ({ ...prev, [widgetKey]: false }))}
                            fieldsLsCacheKey={fieldsLsCacheKey}
                            sortFieldsLsCacheKey={sortFieldsLsCacheKey}
                            destroyOnUnmount
                            withoutFieldsCache={confGridWithoutFieldsCache}
                            withoutSortCache={confGridWithoutSortCache}
                        />
                    </div>
                );
            }

            case "reference": {
                let onLiveSave;
                if (liveSave) {
                    onLiveSave = customLiveSubmit ? handleLiveSubmit(customLiveSubmit) : handleLiveSubmit();
                }
                return (
                    <Field
                        {...defaultProps}
                        title={title}
                        liveSave={liveSave}
                        onLiveSave={liveSave && onLiveSave}
                        t={t}
                        initialValue={initialValues[key]}
                        portalRepositionTrigger={collapseState} // we need to reposition popup on collapseState change
                        delayedRepositionTrigger={layoutCollapse} // we need to reposition popup on layout collapse change (with the animation delay)
                        delayedRepositionDelay={500} // ~ animation delay
                        isCollapsed={collapseState[data.blockKey]}
                        component={Reference}
                        key={widgetKey}
                    />
                );
            }

            case "cust_address": {
                // old data copied from case "multiselect"
                let onMultiSelectOpen = isExt ? () => handleExtSelectOpen(key) : null;
                if (!onMultiSelectOpen && data.onOpen && typeof data.onOpen === "function") {
                    onMultiSelectOpen = data.onOpen;
                }

                let options = [];
                if (data.customAjaxOptions) {
                    options = ajaxOptions[key] && ajaxOptions[key].length ? ajaxOptions[key] : initAjaxOptions;
                } else {
                    options =
                        refKey || rule === "#[callMethod]"
                            ? (extOptions[key] && extOptions[key].options) || []
                            : convertOptions(values);
                }
                // old data copied from case "multiselect"

                // parsing rule
                let customerId = "";
                let customerObjectType = "";
                if (data && typeof data.rule === 'string') {
                    const parts = data.rule.split("@");
                    customerId = parts[0] && /^\d+$/.test(parts[0]) ? parseInt(parts[0], 10) : "";
                    customerObjectType = parts[1] || "";
                } else {
                    console.error("CUST_ADDRESS: 'rule' property is invalid");
                }
                
                return (
                    <Field
                        {...defaultProps}
                        placeholder={t("dontSelect")}
                        noResultsText={t("noItems")}
                        clearValueText={t("clearValue")}
                        initialValues={initialValues && initialValues[key]}
                        options={options}
                        onInputChange={query => setOptionsQuery(query, key, blockKey, data, true)}
                        onOpen={onMultiSelectOpen}
                        disabled={disabled || (isExt && refKey && formValues && !formValues[refKey])} // disabled check for ext ref selects
                        isLoading={extOptionsLoading[key] || data.isLoading}
                        escapeClearsValue={!liveSave}
                        isAsync={data.customAjaxOptions}
                        component={Address}
                        customerId={customerId}
                        customerObjectType={customerObjectType}
                    />
                );
            }

            default: {
                console.log("Widget type is not founded/supported:", widgetType);
                return null;
            }
        }
    };

    const getFieldControllerProps = data => {
        const {
            widgetType,
            // key: widgetKey,
            widgetStyle,
            key,
            refKey,
            values,
            rule,
            clearable,
            customLiveSubmit,
        } = data;

        const disabled = readonly || data.disabled;

        let options = null;
        if (["multiselect", "cust_address"].includes(widgetType)) {
            if (data.customAjaxOptions) {
                const initAjaxOptions =
                ajaxInitOptions[key] && ajaxInitOptions[key].length > 0
                    ? ajaxInitOptions[key]
                    : formValues[`${key}_cached_ajax_options`];
                options = ajaxOptions[key] && ajaxOptions[key].length ? ajaxOptions[key] : initAjaxOptions;
            } else {
                options =
                    refKey || rule === "#[callMethod]"
                        ? (extOptions[key] && extOptions[key].options) || []
                        : convertOptions(values);
            }
        }
        if (["select"].includes(widgetType)) {
            options =
                refKey || rule === "#[callMethod]"
                    ? (extOptions[key] && extOptions[key].options) || []
                    : convertOptions(values);
        }
        if (["searchbox", "ajaxCombo"].includes(widgetType)) {
            // either get _cached_ajax_options, or get initOptions
            const initAjaxOptions =
            formValues &&
            formValues[`${key}_cached_ajax_options`] &&
            formValues[`${key}_cached_ajax_options`].length > 0
                ? formValues[`${key}_cached_ajax_options`]
                : ajaxInitOptions[key];
            options = ajaxOptions[key] && ajaxOptions[key].length ? ajaxOptions[key] : initAjaxOptions;
        }

        const controllerProps = {
            widgetType,
            widgetStyleClass: WIDGET_STYLE_MAP[widgetStyle?.style],
            fieldKey: key,
            initValue: forceInitialValues ? get(forceInitialValues, key) : get(initialValues, key),
            value: get(formValues, key),
            error: get(formErrors, key, ""),
            change,
            loader: <Loader loaderContainerClass="container-loader" loaderClass="input-loader" />,
            autoSave: AUTOSAVE_TYPES.includes(widgetType) || false,
            isForceDirtyToPristine: get(forceDirtyToPristine, key) || false,
            isForceToSubmit: get(isForceToSubmit, key) || false,
            setIsForceToSubmit: (value) => setIsForceToSubmit(prev => ({...prev, [key]: value})),
            onDirtyReset: () => setForceDirtyToPristine(keys => ({ ...keys, [key]: false })),
            enterDisabled: enterDisabledTypes.includes(widgetType),
            disabled,
            clearable,
            // portalPlacement: WIDGETS_WITH_RIGHT_CONTROLLER_POSITION.includes(widgetType) && portalPlacement !== 'left' ? "right" : portalPlacement,
            portalPlacement: portalPlacement !== 'left' ? "right" : portalPlacement,
            showNotification,
            selectOptions: options,
            isSaveOnlyValid: isLiveSaveOnlyValid,
            isForceHiddenController,
            required: data.isReq,
            hasExValue: data.hasExValue,
            onFieldChange: onFieldChange && typeof onFieldChange === 'function' ? (...args) => handleFieldChange(data.fieldAjaxOptionsToResetOnChange, ...args) : null,
        };

        if (liveSave) {
            controllerProps.handleLiveSubmit = customLiveSubmit
                ? handleLiveSubmit(customLiveSubmit)
                : handleLiveSubmit();
        }
        return controllerProps;
    };

    const handleExtGearClick = widget => {
        const params = {
            data: {
                objectId: currentId || objectId,
                objectTypeSpec: objectTypeSpec,
                objectType: objectType,
                paramId: widget.key,
                value: formValues[widget.key],
            },
            jsonType: true
        };
        setIsExtClickLoading(prev => ({...prev, [widget.key]: true}));
        baseService.post("get_external_field_values", params).then(({ success, result }) => {
            setIsExtClickLoading(prev => ({...prev, [widget.key]: false}));
            if (success && result && typeof result === 'object') {
                const widgets = dynData.flatMap(block => block.widgets);
                Object.keys(result).forEach(key => {
                    const widget = widgets.find(widget => widget.key === key);
                    if (widget) {
                        // important to change result "key", not a "widget.key"
                        change(key, result[key]);
                        if (liveSave) {
                            setIsForceToSubmit(prev => ({ ...prev, [key]: true}));
                        }
                    }
                });
                // const responseObject = result || { //using mock for test
                //     "bp@d5218@conn_region@993@20861@*1": [
                //         { "value": "MOCK" },
                //         { "value": "MOCK2" },
                //         { "value": "MOCK3" }
                //     ]
                // };
                // console.log(responseObject);
                // Object.keys(responseObject).forEach(i => {
                //     const accumulatedValue = [];
                //     responseObject[i].forEach(item => {
                //         accumulatedValue.push(item.value);
                //     })
                //     change(widget.key, accumulatedValue)
                // });
            } else {
                console.log("DynamicForm::handleExtGearClick: get_external_field_values request or result is empty");
            }
        }).catch(e => {
            setIsExtClickLoading(prev => ({...prev, [widget.key]: false}));
            console.log("DynamicForm::handleExtGearClick: get_external_field_values request failed", e);
        });
    };

    const renderWidgets = (widgets, key, arrayIndex, field) => {
        return widgets.map(item => {
            let widget = item;
            if (typeof widget === "function") {
                widget = widget(formValues, arrayIndex);
            }
            if (!widget) {
                return;
            }
            // field => FieldArray logic
            const widgetKey = field ? `${field}.${widget.key}` : widget.key;
            const withExtGearBtn = widget && widget.rule === "#[callMethod]";

            const widgetStyleClass = WIDGET_STYLE_MAP[widget?.widgetStyle?.style];
            
            return (
                <div
                    className={cx("widget-wrapper", {
                        hidden: widget.isHidden,
                        [widget.customWidth]: widget.customWidth,
                        [widget.customHeight]: widget.customHeight,
                        'with-ext-gear-button': withExtGearBtn,
                        'full-width-textarea': widget.widgetType === 'multiline',
                        [`widget-style-${widgetStyleClass}`]: !!widgetStyleClass,
                        // [`widget-style-accent-bold`]: true,
                    })}
                >
                    {/* {widget.disabled || WIDGETS_WITHOUT_CONTROLLER.includes(widget.widgetType) ? ( */}
                    <>
                        {WIDGETS_WITHOUT_CONTROLLER.includes(widget.widgetType) ? (
                            renderField({ ...widget, field, blockKey: key, key: widgetKey })
                        ) : (
                            <FieldController {...getFieldControllerProps({ ...widget, key: widgetKey })}>
                                {renderField({ ...widget, field, blockKey: key, key: widgetKey })}
                            </FieldController>
                        )}
                        {withExtGearBtn && (
                            <div
                                className="ext-gear-button button-hover-circle"
                                onClick={() => handleExtGearClick(widget)}
                                alt="External request"
                            >
                                {isExtClickLoading[widget.key] && <Loader loaderContainerClass="gear-container-loader" loaderClass="gear-loader" />}
                                <ReactSVG className="button-icon" src={`/data/svg/navigation/settings.svg`} />
                            </div>
                         )} 
                    </>
                </div>
            );
        });
    };

    const renderBlockContent = (data) => {
        const { key, widgets, disabled, isFieldArray, version } = data;    

        if (data.view === "grid_mod") {
            // new code for adapting widgets data to grid format
            // grid is expecting fields (gridFields) by which it will construct headers
            // and afterwards will map them to construct rows (gridData)

            const initValues = getInitialValuesFromWidgets(widgets, false, withAjaxAndFilesExValue);

            const gridFields = {};
            const gridData = [];
            const gridModKey = `DYNAMIC_FORM_GRID_MOD_WITHOUT_REQUEST_${data.key}`;
            

            const getConvertedFormValue = (widget, values, index) => {
                // Convert timestamp to date if widgetType is "date"
                let value = values[widget.key];
                if (["date", "datetime"].includes(widget.widgetType) && !isNaN(parseInt(value))) {
                    const format = widget.widgetType === "datetime" ? DATE_TIME_VIEW_FORMAT : DATE_VIEW_FORMAT;

                    value = moment(parseInt(value, 10)).format(format);
                }

                // If values array is present, replace savedValue with the corresponding value
                if (widget.values && widget.values.length > 0) {
                    const matchingValue = widget.values.find(v => v.key === value);
                    if (matchingValue) {
                        value = matchingValue.value;
                    }
                }
                // get readable value from the hasExValue data { label, value }
                if (value && typeof value === 'object') {
                    value = value.label || value.key || value.value;
                }
                return value;
            };

            for (let i = 0; i <= widgets.length; i++) {
                const widget = widgets[i];
                if (widget) {
                    // const [widgetKey, rowIdentifier] = widget.key.split('@*');
                    const widgetKey = widget.key.split('@*')[0];
                    const rowIdentifier = parseInt(widget.row, 10);
                    // gridFields[widget.order] = {
                    gridFields[widgetKey] = {
                        name: widget.title,
                        noSorted: true,
                        classWidth: "1"
                        // widgetKey
                    }

                    const arrayIndex = rowIdentifier - 1; // rowIdentifiers are not 0 indexed
                    const value = getConvertedFormValue(widget, initValues);

                    // omit -1 indexing
                    if (arrayIndex !== -1) {
                        const existingIndex = gridData.findIndex(item => item && item.id === arrayIndex + 1);
                        const prevRowData = gridData[existingIndex] || {}
    
                        const updatedData = {
                            ...prevRowData,
                            id: arrayIndex + 1,
                            // [widget.order]: value,
                            [widgetKey]: value,
                        }
                        if (existingIndex >= 0) {
                            gridData[existingIndex] = updatedData;
                        } else {
                            gridData.push(updatedData);
                        }
                        // old approach with wrong total numbers and empty data present
                        // gridData[arrayIndex] = {
                        //     ...prevRowData,
                        //     id: arrayIndex + 1,
                        //     // [widget.order]: value,
                        //     [widgetKey]: value,
                        // }
                    }
                }
            }


            const sortedGridData = gridData
                .sort((a, b) => {
                    if (a.id && b.id) {
                        return a.id - b.id;
                    }
                    return 0;
                })
                // use row index to get correct row in grid
                .map((item, index) => ({ ...item, rowIndex: index + 1 }));


            const init = () => {
                const initData = {
                    key: gridModKey, // not sure about such key yet
                    customGridFields: gridFields,
                    customGridData: {
                        success: true,
                        result: sortedGridData,
                        total: sortedGridData.length
                    },
                    customDefaultId: 'id',
                    limit: sortedGridData.length, // set limit to total fields amount in order to avoid pagination
                };
                return initData;
            };

            //  to be used once backend is ready
            const getGridModRequestParams = rowNum => ({
                ctxObjectType: objectType,
                ctxObjectId: currentId,
                objectType: objectType,
                objectTypeId: objectTypeSpec,
                objectId: currentId,
                openMode: "update",
                curStepNum: "1",
                blockKey: data.key,
                rowNum
            });


            // currently not working properly:
            // sorting (it triggers ui - but nothing happens, we could possible sort on ui by the gridData)
            // pagination - we need to prepare data chunks on our side ?

            const customLiveSubmit = data => {
                const { batchValues } = data;

                const attrCode = Object.keys(batchValues);
                const attrValue = Object.values(batchValues);
                const changeNum = [];
                attrCode.forEach(() => changeNum.push(version));

                const newData = {
                    data: {
                        attrCode,
                        attrValue,
                    },
                    jsonType: true,
                };
                return { data: newData, changeNum, liveSaveUrlKey: "save_dyn_param_batch" };
            };

            const customLiveDelete = data => {
                const { batchValues } = data;

                const newData = {
                    data: {
                        attrCode: batchValues,
                    },
                    jsonType: true,
                };
                return { data: newData, method: "delete", liveSaveUrlKey: "delete_dyn_param_row" };
            };

            const onGridModFormSave = handleLiveSubmit(customLiveSubmit);

            const onGridModFormDelete = handleLiveSubmit(customLiveDelete);

            const isDisabled = widgets.some(widget => widget.disabled);

            return (
                <div className="content-wrapper with-fixed-status dynform-grid-wrapper grid-mod-wrapper">
                    <GridWrapper
                        tuner={init}
                        onCustomGridRefresh={gridKey => console.log({ gridKey })}
                        gridModLabel={data.title}
                        gridModButtonText={t("add")}
                        // gridModDynData={gridModDynData}
                        gridModFormKey={data.key}
                        //  we might not needed it anymore - smart portal will be closed anytime user clicked outside of it
                        //  so it will be closed once user click on collapse button
                        //  we also need to reposition the portal on tab collapse
                        gridModPortalRepositionTrigger={collapseState} // we need to reposition popup on collapseState change
                        gridModDelayedRepositionTrigger={layoutCollapse} // we need to reposition popup on layout collapse change (with the animation delay)
                        gridModDelayedRepositionDelay={500} // ~ animation delay
                        gridModIsCollapsed={collapseState[data.key]}
                        getGridModRequestParams={getGridModRequestParams}
                        onGridModFormSave={onGridModFormSave}
                        onGridModFormDelete={onGridModFormDelete}
                        getGridModConvertedWidgetValue={getConvertedFormValue}
                        gridModDisabled={isDisabled}
                        withoutRefresh
                        key={gridModKey}
                        isGridMod={true}
                    />
                </div>
            );
        }
    
        if (isFieldArray) {
            return (
                <FieldArray
                    t={t}
                    name={key}
                    widgets={widgets}
                    arrayKey={key}
                    renderWidgets={renderWidgets}
                    formValues={formValues}
                    disabled={disabled}
                    onFieldsRemove={handleFieldsRemove}
                    component={FieldArrayComponent}
                />
            );
        }
    
        return renderWidgets(widgets, key);
    };

    const renderDynParams = (data, index) => {
        if (!collapseState) return;
        const { key, title: initTitle, widgets, view, description, filter, isHiddenBlock, disabled, isFieldArray } = data;
        // const trimmedTitle = initTitle && initTitle.trim();
        const forceIgnoreTitle = initTitle === "*";
        const title = initTitle === "*" ? false : initTitle;
        const isOpened = !collapseState[key];
        const hiddenWidgets = widgets.filter(widget => widget.isHidden);

        const blockClassCollapse = cx("block-wrapper", {
            open: isOpened,
            "all-widgets-hidden": hiddenWidgets.length === widgets.length,
            // "no-title": !title
        });
        const blockClassWithoutCollapse = cx("block-wrapper", {
            removed: isHiddenBlock,
            displayed: !isHiddenBlock,
            "all-widgets-hidden": hiddenWidgets.length === widgets.length,
        });
        // if * is returned => ignore all filter IN and OUT params, collapse is hidden
        const isTitleAvailable = !forceIgnoreTitle && (title || filter === "IN" || filter === "OUT");
        const headerClass = isTitleAvailable ? "field-header" : "field-header no-title";
        const fieldsClass = isTitleAvailable
            ? `fields-wrapper ${getViewClass(view)}`
            : `fields-wrapper open no-title ${getViewClass(view)}`;

        // do not render only hidden widgets or blocks with empty widgets (widgets: [])
        // we cannot simply return (undefined/null) here, we need to return an element with binded key and data-key to it
        // if we do return (undefined/null) - there is a possibility of Minified React Error #185
        // caused by non-synced refs (for example - there are 20 refs, but we only returned 18 elements - as the result non-sync)
        const visibleWidgets = Array.isArray(widgets) && widgets.filter(widget => !widget.isHidden);
        if (visibleWidgets && visibleWidgets.length === 0) {
            return (
                <div
                    style={{ zIndex: dynDataLength - index, display: "none" }}
                    data-key={withoutCollapse ? undefined : key}
                    key={key}
                />
            );
        }

        return (
            <div
                className={withoutCollapse ? blockClassWithoutCollapse : blockClassCollapse}
                style={{ zIndex: dynDataLength - index }}
                key={key}
                data-key={withoutCollapse ? undefined : key} // data-key?
            >
                {!withoutCollapse && (
                    <div
                        key={`${key}_header`}
                        className={headerClass}
                        // onClick={() => isTitleAvailable && toggleCollapse(key)}
                    >
                        <div className="title-wrapper">
                            <div className="title">
                                {/* <ReactSVG className="chevron-svg" src="/data/svg/chevron.svg" /> */}
                                <ReactSVG className="chevron-svg" src="/data/svg/chevron-dynform.svg" onClick={() => isTitleAvailable && toggleCollapse(key)}/>
                                {/* {filter === "IN" && <ReactSVG className="filter-svg" src="/data/svg/params-in.svg" />} */}
                                {/* {filter === "OUT" && <ReactSVG className="filter-svg" src="/data/svg/params-out.svg" />} */}
                                <div className={cx("title-text", {"title-text--no-margin": title?.length === 0 || title?.length === 1})}>{title}</div>
                                <div className="title-line"></div>
                            </div>
                        </div>
                        {isOpened && description && <div className="description">{description}</div>}
                    </div>
                )}
                <div
                    className={cx({ [fieldsClass]: fieldsClass, isFieldArray })}
                    ref={refs.current[index]}
                    key={`${key}_content`}
                >
                    {renderBlockContent(data)}
                </div>
            </div>
        );
    };

    useEffect(() => {
        const widgets = dynData.reduce((prev, curr) => [...prev, ...curr.widgets], []);
        if (forceInitialValues) {
            // const defaultValues = getDefaultValuesFromWidgets(widgets);
            const widgetValues = getInitialValuesFromWidgets(widgets, isOnceInitialized, withAjaxAndFilesExValue);
            const mergedValues = { ...forceInitialValues };
            // in some cases forceInitialValues does not include widgets saved or default values, check for them here
            // if there is no value in forceInitValue try to get it from widgetValues
            Object.keys(widgetValues).forEach(key => {
                const currentValue = mergedValues[key];
                const widgetValue = widgetValues[key];
                const isCurrentValueEmpty =
                    [null, undefined, ""].includes(currentValue) ||
                    (Array.isArray(currentValue) && currentValue.length === 0);
                const isWidgetValueAvailable = ![null, undefined, ""].includes(widgetValue);
                // fallback to the widget value
                if (isCurrentValueEmpty && isWidgetValueAvailable) {
                    mergedValues[key] = widgetValue;
                }
            });
            initialize(mergedValues);
        } else {
            const isKeepOnUnmount = "isDestroyOnUnmount" in props ? !props.isDestroyOnUnmount : false;
            const shouldInitialize = !(initialValues && isKeepOnUnmount);
            if (shouldInitialize) {
                const initializeValues = getInitialValuesFromWidgets(widgets, isOnceInitialized, withAjaxAndFilesExValue);
                initialize(initializeValues);
            }
        }

        // const extWidgets = widgets.filter(widget => widget.rule === '#[callMethod]');

        const refWidgets = widgets.filter(widget => widget.refKey);

        const refWidgetsOptions = refWidgets.reduce((prev, curr) => {
            const refWidget = widgets.filter(widget => widget.key === curr.refKey);
            const savedRefValue = refWidget && refWidget[0] && refWidget[0].savedValue;
            const { rule, refKey, key, values } = curr;
            const isExt = rule === "#[callMethod]";
            return {
                ...prev, // set initialValues in redux form in format { key: value }
                [key]: {
                    rule,
                    refKey,
                    initialOptions: isExt ? convertExtValues(values) : values,
                    options: isExt ? convertExtValues(values) : getRefOptions(values, savedRefValue),
                    savedRefValue: isExt ? getValueFromStr(savedRefValue) : savedRefValue,
                },
            };
        }, {});

        const extWidgets = widgets.filter(widget => widget.rule === "#[callMethod]" && !widget.refKey);

        const extWidgetsOptions = extWidgets.reduce((prev, curr) => {
            const { rule, key, values } = curr;
            return {
                ...prev, // set initialValues in redux form in format { key: value }
                [key]: {
                    rule,
                    initialOptions: convertExtValues(values),
                    options: convertExtValues(values),
                },
            };
        }, {});

        const ajaxWidgets = widgets.filter(widget => widget.widgetType === "ajaxCombo");

        const ajaxWidgetsOptions = ajaxWidgets.reduce((prev, curr) => {
            const { key, values } = curr;
            return {
                ...prev,
                [key]: convertOptions(values),
            };
        }, {});

        setAjaxInitOptions(ajaxWidgetsOptions);

        setExtOptions({ ...refWidgetsOptions, ...extWidgetsOptions });

        // set collapsed from store or init local initial state (either pass it to store or leave local)
        if (
            setFormCollapse &&
            formCollapse &&
            !isEmpty(formCollapse[mainId]) &&
            !isEmpty(formCollapse[mainId][currentId])
        ) {
            setCollapseState(formCollapse[mainId][currentId]);
        } else {
            const initialCollapse = dynData.reduce((prev, curr) => ({ ...prev, [curr.key]: !!+curr.collapsed }), {});
            setCollapseState(initialCollapse);
        }

        // init hidden values widgets
        const hiddenValuesWidgets = widgets.filter(widget => widget.isHiddenByConfig && widget.hiddenValues);
        // console.log({hiddenValuesWidgets});
        hiddenValuesWidgets.forEach(widget => {
            change(widget.key, widget.hiddenValues);
        });
    }, []);

    // refresh collapseStatee in case isRefreshFormCollapse is provided
    useEffect(() => {
        if (
            setFormCollapse &&
            setIsRefreshFormCollapse &&
            typeof setIsRefreshFormCollapse === "function" &&
            formCollapse &&
            !isEmpty(formCollapse[mainId]) &&
            !isEmpty(formCollapse[mainId][currentId])
        ) {
            setIsRefreshFormCollapse(false);
            setCollapseState(formCollapse[mainId][currentId]);
        }
    }, [isRefreshFormCollapse]);

    useEffect(() => {
        // listen to refs ready state (if ref.current === null then return)
        if (!heights && refs.current.some(ref => ref.current)) {
            const { current } = refs;
            setHeights(
                current.reduce((prev, curr) => {
                    // probably block with no widgets is rendered
                    if (!curr || !curr.current) {
                        return prev;
                    }
                    return {
                        ...prev,
                        [curr.current.parentElement.getAttribute("data-key")]: curr.current.offsetHeight + 12,
                    };
                }, {})
            );
        }
    });

    useEffect(() => {
        if (!isEmpty(collapseState) && setFormCollapse) {
            setFormCollapse(
                mainId,
                formCollapse ? { ...formCollapse[mainId], [currentId]: collapseState } : { [currentId]: collapseState }
            );
        }
    }, [collapseState]);

    useEffect(() => {
        if (blockOffsetKey) {
            const filteredBlock = refs.current.filter(ref => {
                return ref.current && ref.current.parentElement && ref.current.parentElement.getAttribute("data-key") === blockOffsetKey;
            });
            // console.log({filteredBlock});
            if (filteredBlock && filteredBlock[0]) {
                const {
                    current: { parentElement },
                } = filteredBlock[0];
    
                // console.log({parentElement, offsetTop: parentElement.offsetTop, height: parentElement.clientHeight});
                // setBlockOffset(parentElement.offsetTop + parentElement.clientHeight);
                setBlockOffset(parentElement.offsetTop);
            }
        }
    }, [blockOffsetKey]);

    // useEffect for handling ref / ext options (updating ref ext options if parent option changed or cleared)
    useEffect(() => {
        if (formValues && !isEmpty(extOptions)) {
            Object.keys(extOptions).map(fieldKey => {
                const extOption = extOptions[fieldKey];
                if (extOption.refKey) {
                    const { refKey, savedValue, rule } = extOption;
                    const currValue = formValues[refKey];
                    if (savedValue !== currValue) {
                        return handleExtRefChange(fieldKey, refKey, rule);
                    }
                }
            });
        }
    }, [formValues]);

    // handle resetValues useEffects below:
    // used to clear some fields value once their "binded" field values are changed
    useEffect(() => {
        // update resetKeySavedValues
        if (formValues && !isEmpty(resetKeyFields)) {
            const newValues = {};
            Object.keys(resetKeyFields).forEach(key => {
                const val = get(formValues, key);
                newValues[key] = val;
            });
            setResetKeySavedValues(prev => ({ ...prev, ...newValues }));
        }
    }, [formValues, resetKeyFields]);

    useEffect(() => {
        // clear fields once resetKeyValue is changed
        if (formValues && !isEmpty(resetKeySavedValues)) {
            setTimeout(() => {
                Object.keys(resetKeyFields).forEach(resetKey => {
                    const fields = resetKeyFields[resetKey];
                    fields.forEach(widgetKey => {
                        // check if fields are still exist
                        if (!regFields[widgetKey] || !regFields[resetKey]) {
                            if (!regFields[resetKey]) {
                                // completely remove resetKey
                                setResetKeyFields(prev => {
                                    delete prev[resetKey];
                                    return { ...prev };
                                });
                                setResetKeySavedValues(prev => {
                                    delete prev[resetKey];
                                    return { ...prev };
                                });
                            } else if (!regFields[widgetKey]) {
                                // remove single widgetKey inside of resetKey array
                                setResetKeyFields(prev => {
                                    return {
                                        ...prev,
                                        [resetKey]: prev[resetKey].filter(item => item !== widgetKey),
                                    };
                                });
                            }
                            // console.log({resetKeyFields, resetKeySavedValues});
                        } else {
                            // field is still exist - make reset
                            const fieldValue = get(formValues, widgetKey);
                            if (fieldValue) {
                                const savedResetVal = get(resetKeySavedValues, resetKey);
                                const currentResetVal = get(formValues, resetKey);
                                const isValuesEqual = isEqual(savedResetVal, currentResetVal);
                                if (!isValuesEqual) {
                                    // previously was deleted a field array fields => wait until next cycle to finally compare sync values
                                    if (lastDeletedArrayFieldName && widgetKey.startsWith(lastDeletedArrayFieldName)) {
                                        setLastDeletedArrayFieldName(null);
                                    } else {
                                        change(widgetKey, null);
                                    }
                                }
                            }
                        }
                    });
                });
            }, 0);
        }
    }, [formValues]);

    useEffect(() => {
        if (submitFailed && !isEmpty(formErrors)) {
            if (props.touch && typeof props.touch === "function") {
                props.touch(formName, ...Object.keys(formErrors));
            }
        }
    }, [submitFailed]);

    return (
        <Form
            onSubmit={handleSubmit(() => submitForm(formName))}
            className={!className ? "order-dynamic-form" : `order-dynamic-form ${className}`}
        >
            {dynData && !isEmpty(collapseState) && initialValues && dynData.map(renderDynParams)}
        </Form>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(reduxFormWrapper({ validate })(DynamicForm));
